import { useEffect, useState } from 'react';
import {
    Form,
    Container,
    Row,
    Col,
    Button,
    Stack,
    ListGroup,
    Modal,
    Card,
    Spinner,
    Badge,
    Dropdown,
} from 'react-bootstrap';
import { Check, ThumbsDown, Plus, ThumbsUp, Download } from 'lucide-react';
import './eyetestList.scss';
import eyetestApi, {
    useEyetestAddMutation,
    useEyeTestByIdMutation,
    useEyetestEditMutation,
    useEyeTestImageByIdMutation,
    useOpthAIdetailsMutation,
    useReferralLetterByTestIdMutation,
    useSummaryreportTestIdMutation,
    useStatusChangeMutation,
    useTestNamesMutation,
    useUpload1Mutation,
    useUpload2Mutation,
    useUpload3Mutation,
} from './eyetestApi';
import { useAllPatientListMutation } from '../Patient/patientApi';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import Step4 from './step4';
import LoadingComponent from '../LoadingComponent';
import { Link, useLocation, useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { formatDate, toCamelCase } from '../../helper';
import { useTranslation } from 'react-i18next';
import config from '../../Api/config';
import EyeTestStatus from './eyeTestStatus';
import { usePosListMutation } from '../Pos/posApi';
import { useOpticianListMutation } from '../Optician/opticianApi';
import { useDoctorListMutation } from '../Doctor/doctorApi';
import AssignDoc from './assignDoc';
import { getSecureItem } from "../../utils/secureStorage";
const EyeTestView = () => {
    const user = getSecureItem('UserData');
    const { t, i18n } = useTranslation();
    const { state } = useLocation();

    console.log('state ======= > ', state);

    const navigate = useNavigate();
    const [testNames] = useTestNamesMutation();
    const [addEyeTest] = useEyetestAddMutation();
    const [posListMutation] = usePosListMutation();
    const [opthAIdetails] = useOpthAIdetailsMutation();
    const [doctorListMutation] = useDoctorListMutation();
    const [opticianListMutation] = useOpticianListMutation();
    const [patientListMutation] = useAllPatientListMutation();
    const [referralLetterByTestId] = useReferralLetterByTestIdMutation();
    const [summaryreportTestId] = useSummaryreportTestIdMutation();
    const [editEyeTest] = useEyetestEditMutation();
    const [imageUpload1] = useUpload1Mutation();
    const [imageUpload2] = useUpload2Mutation();
    const [imageUpload3] = useUpload3Mutation();
    const [error, setError] = useState({});
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [imageLoading, setImageLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [getEyeTest] = useEyeTestByIdMutation();
    const [getEyeTestImage] = useEyeTestImageByIdMutation();
    const [images, setImages] = useState({
        image1: '',
        image2: '',
        image3: '',
    });

    const [ophtAIData, setOphtAIData] = useState({});
    const [symReportData, setSymReportData] = useState({});
    const [eyeTestData, setEyeTestData] = useState({});
    const [prescriptionPath, setPrescriptionPath] = useState('');
    const [downloadLoading, setDownloadLoading] = useState(false);
    useEffect(() => {
        console.log(
            'EYETESTDATA ==============================> ',
            eyeTestData
        );
    }, [eyeTestData]);
    const [eyeTestImages, setEyeTestImages] = useState({});

    useEffect(() => {
        // debugger
        const token = getSecureItem('authToken');
        if (loading) {
            (async () => {
                await posListMutation({ email: '', mobile: '' });
                const eyeTestData = await getEyeTest({ eyeTestID: state.id });

                if (!!eyeTestData.data[0]?.opthAIResult) {
                    // Fetch OpthAI data
                    (async () => {
                        const url = `${config.EXTENDED_API_URL}/${state.id}`;
                        try {
                            const response = await fetch(url);
                            if (!response.ok) {
                                throw new Error(
                                    `Response status: ${response.status}`
                                );
                            }

                            const json = await response.json();
                            setOphtAIData(json);
                        } catch (error) {
                            console.error(error.message);
                        }
                        let data = await opthAIdetails(state.id);
                    })();

                    // Fetch SymReport data
                    (async () => {
                        try {
                            const response = await fetch(
                                `${config.API_URL}/eyetests/OpthAIdetails?eyetestid=${state.id}`,
                                {
                                    method: 'POST',
                                    headers: {
                                        accept: 'text/plain',
                                        Authorization: `Bearer ${token}`,
                                    },
                                }
                            );

                            if (!response.ok) {
                                throw new Error(
                                    `Response status: ${response.status}`
                                );
                            }

                            const data = await response.json();
                            setSymReportData(data);
                        } catch (error) {
                            console.error(
                                'Error fetching SymReport:',
                                error.message
                            );
                        }
                    })();
                }

                let tempTestDetails =
                    user?.userType === 'EYEDOCTOR'
                        ? cloneLastRecommendations(
                            eyeTestData.data[0]?.testDetails
                        )
                        : eyeTestData.data[0]?.testDetails;
                setEyeTestData({
                    ...eyeTestData.data[0],
                    testDetails: tempTestDetails,
                    needPrescription:
                        eyeTestData.data[0]?.needPrescription == 'Yes'
                            ? true
                            : false,
                    patientDOB: formatDate(eyeTestData.data[0]?.patientDOB),
                    createdDate: formatDate(eyeTestData.data[0]?.createdDate),
                    imagesVues: eyeTestData.data[0]?.infoImagesVues,
                    lastTimeWentToEyeDoc:
                        eyeTestData.data[0]?.lastTimeWentToEyeDoc == ''
                            ? ''
                            : formatDate(
                                eyeTestData.data[0]?.lastTimeWentToEyeDoc
                            ),
                });
                setLoading(false);
                setImageLoading(true);
            })();
        }
    }, [loading]);

    useEffect(() => {
        if (imageLoading) {
            (async () => {
                const eyeTestImageData = await getEyeTestImage({
                    eyeTestID: state.id,
                });
                setEyeTestImages(eyeTestImageData.data);
            })();
        }
    }, [imageLoading]);

    const cloneLastRecommendations = (originalData) => {
        const data = [...originalData];

        // Clone items at indices 6 and 7
        const item7Clone = { ...data[6], testType: 'Prescription finale' };
        const item8Clone = { ...data[7], testType: 'Prescription finale' };

        // Optionally update orderNo to avoid duplicates
        const maxOrderNo = Math.max(...data.map((item) => item.orderNo));
        item7Clone.orderNo = maxOrderNo + 1;
        item8Clone.orderNo = maxOrderNo + 2;

        // Push the cloned items
        return [...data, item7Clone, item8Clone];
    };

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;

        if (name === 'resultExamine') {
            setEyeTestData((prev) => {
                return {
                    ...prev,
                    [name]: value,
                    infoResultExamine: value,
                };
            });
        } else {
            setEyeTestData((prev) => {
                return {
                    ...prev,
                    [name]: value,
                };
            });
        }

        if (name === 'doYouWearGlasses') {
            setEyeTestData((prev) => {
                return {
                    ...prev,
                    [name]: value,
                    doYouWearGlasses: (value == 'true' ? true : false),
                };
            });
        } else {
            setEyeTestData((prev) => {
                return {
                    ...prev,
                    [name]: value,
                };
            });
        }
    };

    const imageHandle = (e) => {
        setImages((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.files[0],
            };
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity()) {
            setButtonLoading(true);
            editEyeTest({
                ...eyeTestData,
                testno: eyeTestData.testid,
                InfoSubmitTrack: 'Web',
            }).then(async (data) => {
                if (data.error.data) {
                    let formData = new FormData();
                    formData.append('EyeTestId', data.error.data);

                    if (images.image1) {
                        formData.append('EyeTestImage', images.image1);
                        await imageUpload1(formData);
                    }
                    if (images.image2) {
                        formData.append('EyeTestImage', images.image2);
                        await imageUpload2(formData);
                    }
                    if (images.image3) {
                        formData.append('EyeTestImage', images.image3);
                        await imageUpload3(formData);
                    }
                }
                setButtonLoading(false);
                navigate(`/eyetest/list`);
            });
        }

        setValidated(true);
    };

    const handleReferenceLetterDownload = async () => {
        setDownloadLoading(true);
        try {
            const data = await referralLetterByTestId({
                eyeTestID: eyeTestData?.testid,
            });
            console.log('referralLetterByTestId ++++++>> ', data);
            const url = data?.data?.referralletterUrl;
            console.log('url +++++++> ', url);

            if (url) {
                // Solution 1: Use fetch + blob download (works in incognito)
                try {
                    const response = await fetch(url);
                    const blob = await response.blob();
                    const blobUrl = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = url.split('/').pop() || 'ReferralLetter.pdf';
                    document.body.appendChild(a);
                    a.click();

                    // Cleanup
                    window.URL.revokeObjectURL(blobUrl);
                    document.body.removeChild(a);
                } catch (fetchError) {
                    console.log(
                        'Fetch approach failed, falling back to direct download'
                    );

                    // Solution 2: Direct download as fallback
                    const a = document.createElement('a');
                    a.href = url;
                    a.target = '_blank';
                    a.rel = 'noopener noreferrer';
                    a.download = url.split('/').pop() || 'ReferralLetter.pdf';
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(() => {
                        document.body.removeChild(a);
                    }, 100);
                }
            }
        } catch (error) {
            console.error('Download failed:', error);
            // Optionally show error to user
        } finally {
            setDownloadLoading(false);
        }
    };
    const handlesummaryreportDownload = async () => {
        setDownloadLoading(true);
        try {
            const data = await summaryreportTestId({
                eyeTestID: eyeTestData?.testid,
            });
            console.log('summaryreportTestId ++++++>> ', data);
            const url = data?.data?.finalSummaryReport;
            console.log('url +++++++> ', url);

            if (url) {
                // Solution 1: Use fetch + blob download (works in incognito)
                try {
                    const response = await fetch(url);
                    const blob = await response.blob();
                    const blobUrl = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = url.split('/').pop() || 'Summaryreport.pdf';
                    document.body.appendChild(a);
                    a.click();

                    // Cleanup
                    window.URL.revokeObjectURL(blobUrl);
                    document.body.removeChild(a);
                } catch (fetchError) {
                    console.log(
                        'Fetch approach failed, falling back to direct download'
                    );

                    // Solution 2: Direct download as fallback
                    const a = document.createElement('a');
                    a.href = url;
                    a.target = '_blank';
                    a.rel = 'noopener noreferrer';
                    a.download = url.split('/').pop() || 'ReferralLetter.pdf';
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(() => {
                        document.body.removeChild(a);
                    }, 100);
                }
            }
        } catch (error) {
            console.error('Download failed:', error);
            // Optionally show error to user
        } finally {
            setDownloadLoading(false);
        }
    };
    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <>
            {eyeTestData ? (
                <>
                    <Container fluid>
                        <Stack direction="horizontal" gap={3} className="pb-4">
                            <div className="d-flex align-items-center justify-content-between w-100 gap-2">
                                <div
                                    className="test_view_status"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '20px',
                                    }}
                                >
                                    <div className="test_view_status">
                                        {t('status')} :{' '}
                                        <Badge className="">
                                            {t(
                                                toCamelCase(eyeTestData?.status)
                                            )}
                                        </Badge>
                                    </div>
                                    {['New'].includes(eyeTestData?.status) &&
                                        ['ADMIN', 'BACKOFFICE'].includes(
                                            user?.userType
                                        ) &&
                                        !user?.isExternal && (
                                            <AssignDoc
                                                idSum={[eyeTestData.testid]}
                                                setLoading={setLoading}
                                            />
                                        )}
                                </div>
                                <div className="w-auto d-flex align-items-center justify-content-between gap-4">
                                    {!state.edit && eyeTestData?.status === 'Approved' &&
                                        eyeTestData?.needPrescription && (
                                            <>
                                                {(user?.userType === 'PATIENT' ||
                                                    user?.userType === 'OPTICIAN' ||
                                                    (user?.userType ===
                                                        'ADMIN' &&
                                                        eyeTestData?.showPrescriptiontoOptician ===
                                                        'Yes')) && (
                                                        <Button
                                                            variant="light"
                                                            style={{
                                                                marginRight: 10,
                                                            }}
                                                            onClick={() =>
                                                                handlesummaryreportDownload()
                                                            }
                                                            disabled={downloadLoading}
                                                        >
                                                            {downloadLoading && (
                                                                <Spinner
                                                                    animation="border"
                                                                    role="status"
                                                                    size="sm"
                                                                >
                                                                    <span className="visually-hidden">
                                                                        Loading...
                                                                    </span>
                                                                </Spinner>
                                                            )}{' '}
                                                            <Download
                                                                width={16}
                                                                style={{
                                                                    marginRight: '6px',
                                                                }}
                                                            />{' '}
                                                            {t("Télécharger le résumé du test")}
                                                        </Button>
                                                    )}
                                            </>
                                        )}
                                    { !state.edit && eyeTestData?.isDoctorNewComment &&
                                        (user?.userType === 'PATIENT' ||
                                            user?.userType === 'ADMIN' || user?.userType === 'OPTICIAN'|| user?.userType === 'EYEDOCTOR') && (
                                            <Button
                                                variant="light"
                                                style={{
                                                    marginRight: 10,
                                                }}
                                                onClick={() =>
                                                    handleReferenceLetterDownload()
                                                }
                                                disabled={downloadLoading}
                                            >
                                                {downloadLoading && (
                                                    <Spinner
                                                        animation="border"
                                                        role="status"
                                                        size="sm"
                                                    >
                                                        <span className="visually-hidden">
                                                            Loading...
                                                        </span>
                                                    </Spinner>
                                                )}{' '}
                                                <Download
                                                    width={16}
                                                    style={{
                                                        marginRight: '6px',
                                                    }}
                                                />{' '}
                                                {t("Télécharger lettre d'adressage")}
                                            </Button>
                                        )}
                                    {/* condition for both the report and dropdown */}
                                    {!state.edit && Object.keys(ophtAIData).length > 0 &&
                                        !!ophtAIData?.info_ReportDocumentPath &&
                                        symReportData?.opthAIReportPath ? (
                                        user?.userType === 'ADMIN' ||
                                            user?.userType === 'BACKOFFICE' ? (
                                            <Dropdown>
                                                <Dropdown.Toggle
                                                    variant="primary"
                                                    id="dropdown-basic"
                                                // disabled={user?.userType == 'PATIENT'}
                                                >
                                                    <Plus
                                                        width={14}
                                                        height={14}
                                                    />{' '}
                                                    {t('Télécharger')}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        as="a"
                                                        href={`${config.img_URL}/${ophtAIData?.info_ReportDocumentPath}`}
                                                        target="_blank"
                                                        download
                                                    >
                                                        {t('Rapport OphtAI')}
                                                    </Dropdown.Item>

                                                    <Dropdown.Item
                                                        as="a"
                                                        href={`${config.img_URL}/${symReportData?.opthAIReportPath}`}
                                                        target="_blank"
                                                        download
                                                    // disabled
                                                    >
                                                        {t('Rapport Sym IA')}
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        ) : (
                                            <Button
                                                href={`${config.img_URL}/${symReportData.opthAIReportPath}`}
                                                target="_blank"
                                            >
                                                {t('downloadSymReport')}
                                            </Button>
                                        )
                                    ) : (
                                        <>
                                            {/* condition for sym ia report */}
                                            {Object.keys(ophtAIData).length >
                                                0 &&
                                                !!ophtAIData?.info_ReportDocumentPath && (
                                                    <>
                                                        {user.userType ===
                                                            'ADMIN' ||
                                                            user.userType ===
                                                            'BACKOFFICE' ? (
                                                            <Button
                                                                className="pl-1"
                                                                href={`${config.img_URL}/${ophtAIData?.info_ReportDocumentPath}`}
                                                                target="_blank"
                                                            >
                                                                {t(
                                                                    'downloadReport'
                                                                )}
                                                            </Button>
                                                        ) : null}
                                                    </>
                                                )}

                                            {/* condition for opthai report */}
                                            { !state.edit && symReportData?.opthAIReportPath && (
                                                <>
                                                    {user?.userType ===
                                                        'EYEDOCTOR' ||
                                                        user.userType === 'ADMIN' ||
                                                        user.userType ===
                                                        'BACKOFFICE' ||
                                                        user.userType ===
                                                        'PATIENT' ? (
                                                        <Button
                                                            href={`${config.img_URL}/${symReportData.opthAIReportPath}`}
                                                            target="_blank"
                                                        >
                                                            {t(
                                                                'downloadSymReport'
                                                            )}
                                                        </Button>
                                                    ) : null}
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between w-auto gap-3">
                                {state.edit ? (
                                    <Button
                                        onClick={handleSubmit}
                                        variant="primary"
                                        disabled={buttonLoading}
                                    >
                                        {buttonLoading && (
                                            <Spinner
                                                animation="border"
                                                role="status"
                                                size="sm"
                                            >
                                                <span className="visually-hidden">
                                                    Loading...
                                                </span>
                                            </Spinner>
                                        )}{' '}
                                        {t('saveChanges')}
                                    </Button>
                                ) : (
                                    ''
                                )}
                                {!state.edit && eyeTestData?.status === 'Approved' &&
                                    eyeTestData?.needPrescription && (
                                        <>
                                            {(user?.userType === 'EYEDOCTOR' ||
                                                user?.userType === 'PATIENT' ||
                                                user?.userType === 'OPTICIAN' ||
                                                user?.userType === 'ADMIN' ||
                                                (user?.userType ===
                                                    'BACKOFFICE' &&
                                                    eyeTestData?.showPrescriptiontoOptician ===
                                                    'Yes')) && (
                                                    <Button
                                                        onClick={() =>
                                                            navigate(
                                                                '/prescription',
                                                                {
                                                                    state: {
                                                                        id: eyeTestData.testid,
                                                                    },
                                                                }
                                                            )
                                                        }
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 2,
                                                        }}
                                                    >
                                                        <span>📄</span>
                                                        <span
                                                            style={{
                                                                fontSize: '12px',
                                                            }}
                                                        >
                                                            {t('prescription')}
                                                        </span>
                                                    </Button>
                                                )}
                                        </>
                                    )}
                                {(user.userType === 'ADMIN' ||
                                    user.userType === 'BACKOFFICE' ||
                                    user.userType === 'OPTICIAN') &&
                                    !user?.isExternal &&
                                    state.glass &&
                                    eyeTestData?.status !== 'Not Approved' &&
                                    state.edit != true && (
                                        <Button
                                            onClick={() =>
                                                navigate('/order/list', {
                                                    state: {
                                                        addOrder: true,
                                                        eyeData: eyeTestData,
                                                    },
                                                })
                                            }
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 2,
                                            }}
                                        >
                                            <span>📦</span>
                                            <span
                                                style={{
                                                    fontSize: '12px',
                                                }}
                                            >
                                                {t('commandes')}
                                            </span>
                                        </Button>
                                    )}
                                {/* <Button
                                    onClick={() =>
                                        navigate('/prescription', {
                                            state: {
                                                id: eyeTestData.testid,
                                            },
                                        })
                                    }
                                    style={{
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <span>📝</span>
                                    <span style={{
                                        fontSize: "12px"
                                    }}>
                                        {t('prescription')}
                                    </span>
                                </Button>
                                <Button
                                    onClick={() =>
                                        navigate('/order/list', {
                                            state: {
                                                addOrder: true,
                                                eyeData: eyeTestData,
                                            },
                                        })
                                    }
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <span>📄</span>
                                    <span style={{
                                        fontSize: "12px"
                                    }}>
                                        {t('commandes')}
                                    </span>
                                </Button> */}
                            </div>
                        </Stack>

                        <Form
                            noValidate
                            validated={validated}
                            onSubmit={handleSubmit}
                        >
                            <div className="mb-4">
                                <h4 className="mb-2">{t('basicInfo')}</h4>
                                <Step1
                                    setAddEyeTestConfig={setEyeTestData}
                                    addEyeTestConfig={eyeTestData}
                                    handleChange={handleChange}
                                    imageHandle={imageHandle}
                                    eyeTestImages={eyeTestImages}
                                    view={!state.edit ? 'view' : 'edit'}
                                    glass={state.glass}
                                />
                            </div>
                            <div
                                className={`${!state.edit
                                        ? 'custom_disabled mb-4'
                                        : 'mb-4'
                                    }`}
                            >
                                <h4 className="mb-2">{t('symptoms')}</h4>
                                <Step2
                                    setAddEyeTestConfig={setEyeTestData}
                                    addEyeTestConfig={eyeTestData}
                                    view={!state.edit ? 'view' : 'edit'}
                                />
                            </div>

                            <div className="mb-4">
                                <h4 className="mb-2">{t('eyetestView')}</h4>
                                <Step3
                                    setAddEyeTestConfig={setEyeTestData}
                                    addEyeTestConfig={eyeTestData}
                                    handleChange={handleChange}
                                    imageHandle={imageHandle}
                                    eyeTestImages={eyeTestImages}
                                    glass={state.glass}
                                    view={!state.edit ? 'view' : 'edit'}
                                />
                            </div>
                            {user?.userType !== 'PATIENT' ? (
                                <div className="mb-4">
                                    <h4 className="mb-2">{t('comments')}</h4>
                                    <Step4
                                        error={error}
                                        setAddEyeTestConfig={setEyeTestData}
                                        addEyeTestConfig={eyeTestData}
                                        handleChange={handleChange}
                                        glass={state.glass}
                                        consent={false}
                                        view={!state.edit ? 'view' : 'edit'}
                                    />
                                </div>
                            ) : (
                                ''
                            )}
                        </Form>
                        {user?.userType == 'EYEDOCTOR' &&
                            eyeTestData.status == 'New' ? (
                            <EyeTestStatus
                                eyeTestData={eyeTestData}
                                setError={setError}
                            />
                        ) : (
                            ''
                        )}
                    </Container>
                </>
            ) : (
                <Container className="mt-5">
                    <Row className="justify-content-center">
                        <Col md={6}>
                            <Card className="text-center">
                                <Card.Body>
                                    <h2>{t('noDataAvailable')}</h2>
                                    <Link to="/dashboard">
                                        <Button variant="primary">
                                            Go Home
                                        </Button>
                                    </Link>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            )}
        </>
    );
};

export default EyeTestView;
